import { useState } from "react";
import { fmt } from "../lib/api";
import { netType } from "../lib/reports";
import { NetFilter, applyNetFilter } from "./NetFilter";
import { UserHeatMap } from "./UserHeatMap";

const speedBad = (t) => t.issues.some((i) => /download|upload/i.test(i));

export const RepHistory = ({ items }) => {
  const [f, setF] = useState({ isp: "", net: "" });
  const shown = applyNetFilter(items, f);
  return (
    <section className="mx-5 mt-8" data-testid="rep-history">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="text-xs text-neutral-400 font-medium">Your recent tests</div>
        {items.length > 0 && (
          <div className="flex gap-2">
            <NetFilter tests={items} value={f} onChange={setF} prefix="rep-" className="field !py-1.5 !px-2 !text-[11px] !rounded-full" />
          </div>
        )}
      </div>
      <UserHeatMap tests={shown} />
      {!shown.length && <div className="text-xs text-neutral-600">{items.length ? "No tests match this filter." : "No tests yet."}</div>}
      {shown.length > 0 && (
        <div className="rounded-2xl bg-white/[0.03] border border-white/[0.06] divide-y divide-white/[0.05] overflow-hidden">
          {shown.map((t) => (
            <div key={t.id} className="px-4 py-3 text-xs" data-testid={`rep-history-row-${t.id}`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className={`w-2 h-2 rounded-full ${speedBad(t) ? "bg-[#FF3B30]" : "bg-[#32D74B]"}`} />
                  <span className="text-neutral-400">{new Date(t.created_at).toLocaleString([], { dateStyle: "short", timeStyle: "short" })}</span>
                </div>
                <span className={`tabular-nums ${speedBad(t) ? "text-[#FF6B61]" : "text-neutral-200"}`}>
                  ↓{fmt(t.download_mbps)} · ↑{fmt(t.upload_mbps)} · {fmt(t.ping_ms, 0)}ms
                </span>
              </div>
              <div className="text-[10px] text-neutral-600 mt-1 ml-4">{t.isp || "Unknown"} · {netType(t)}{t.location?.city ? ` · ${t.location.city}` : ""}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
